import { Status } from '@df/core/status';
import { Address } from '@df/session/api/address-book/address';
import { Customer } from '@df/session/api/customer';
import { HistoryOrderItem, historyOrderItemFactory } from '@df/session/api/history/history-order-item';
import { OrderService } from '@df/session/api/order/order.service';
import { Nexus } from '@tomandco/nexus-api-types';
import map from 'lodash-es/map';
import reduce from 'lodash-es/reduce';

/**
 * @deprecated use Nexus.Lib.Customer.Order.HistoryOrderPaymentMethod instead
 */
export type IHistoryOrderDataPaymentMethod = Nexus.Lib.Customer.Order.HistoryOrder['payment_method'];

/**
 * @deprecated use Nexus.Lib.Customer.Order.HistoryOrder instead
 */
export interface IHistoryOrderData extends Nexus.Lib.Customer.Order.HistoryOrder {}

/**
 * @deprecated use Nexus.Lib.Customer.Order.HistoryOrderTotalsData instead
 */
export type IHistoryOrderTotals = Nexus.Lib.Customer.Order.HistoryOrderTotalsData;

/**
 * @deprecated use Nexus.Lib.Customer.Order.HistoryOrderTrackingData instead
 */
export type IHistoryTrackingItem = Nexus.Lib.Customer.Order.HistoryOrderTrackingData;

export class HistoryOrder {
    protected _data!: Nexus.Lib.Customer.Order.HistoryOrder;

    qty!: number;
    items!: HistoryOrderItem[];
    billing?: Address;
    shipping?: Address;

    constructor(
        data: Nexus.Lib.Customer.Order.HistoryOrder,
        private customer: Customer,
        private orderService: OrderService
    ) {
        this.data = data;
    }

    cancelStatus: Status = new Status();

    get id(): number {
        return this._data.id;
    }

    set data(data: Nexus.Lib.Customer.Order.HistoryOrder) {
        this.setData(data);
    }

    get data(): Nexus.Lib.Customer.Order.HistoryOrder {
        return this._data;
    }

    get canCancelByDate(): Date | boolean {
        return this.orderService.canCancelByDate(this.data.date);
    }

    get isCanceled(): boolean {
        const status = this.data.status.toLowerCase();
        return ['canceled', 'cancelled'].includes(status);
    }

    get isClosed(): boolean {
        return this.data.status.toLowerCase() === 'closed';
    }

    cancel = () => {
        this.orderService.cancel(this.cancelStatus, this.data.number, this.customer.model.data.email || '', result =>
            this.onCancelOrderSuccess(result)
        );
    };

    private onCancelOrderSuccess(result) {
        this.data = result.customer.order;
    }

    protected setData(data: IHistoryOrderData) {
        this.items = map(data.items, item => new historyOrderItemFactory.instance(item)) || [];
        this.billing = data.billing ? new Address(data.billing) : undefined;
        this.shipping = data.shipping ? new Address(data.shipping) : undefined;
        this.qty = reduce(this.items, (qty, item) => qty + item.data.qty_ordered, 0);
        this._data = data;
    }
}

export const historyOrderFactory = {
    instance: HistoryOrder
};
